import { createFileRoute } from '@tanstack/react-router';
import BaseView from 'containers/Base/BaseView';
import { baseModuleConfigs } from 'containers/Base/baseModuleConfigs';
import { reportsSchema, useReportsCustomList } from 'containers/Reports/useReports';

function ReportsRoute() {
  const customList = useReportsCustomList();
  return (
    <BaseView
      configuration={baseModuleConfigs.Reports}
      customList={customList}
      customSchema={reportsSchema}
    />
  );
}

export const Route = createFileRoute('/_authenticated/reports')({
  component: ReportsRoute,
});
